import { useState } from 'react';
import ThemeProvider from 'components/v2/ThemeProvider';
import { LoadingRoot, LoadingContent, LoadingMessage, ProgressBar } from './Loading.styles';

const Loading = ({ message = 'Loading itrvl...', fadeOut }) => {
  const [unmounted, setUnmounted] = useState(false);

  if (unmounted) return null;

  return (
    <ThemeProvider>
      <LoadingRoot
        data-test-id="loading-screen"
        fadeOut={fadeOut}
        onTransitionEnd={e => {
          if (e.propertyName === 'opacity' && fadeOut) setUnmounted(true);
        }}
      >
        <LoadingContent>
          <LoadingMessage>{message}</LoadingMessage>
          <ProgressBar />
        </LoadingContent>
      </LoadingRoot>
    </ThemeProvider>
  );
};

export default Loading;
